import { useEffect, useState, useRef } from "react";

import debounce from "lodash/debounce";

// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
// https://medium.com/the-non-traditional-developer/how-to-use-an-intersectionobserver-in-a-react-hook-9fb061ac6cb5
const useIntersect = ({ root = null, rootMargin, threshold = 0 }) => {
  const [entry, updateEntry] = useState({});
  const [node, setNode] = useState(null);

  const observer = useRef(null);

  useEffect(
    debounce(() => {
      if (!observer.current) {
        observer.current = new window.IntersectionObserver(
          ([entryy]) => updateEntry(entryy),
          {
            root,
            rootMargin,
            threshold,
          },
        );
      }

      const { current: currentObserver } = observer;
      // Do not observe node, if node is hidden
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
      if (node && node.offsetParent != null) currentObserver.observe(node);
      return () => currentObserver.disconnect();
    }, 50),
    [node, root, rootMargin, threshold],
  );

  return [setNode, entry];
};

export default useIntersect;
